import React, { Component } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';

// Validation schema
const validationSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  description: Yup.string().required('Description is required'),
  sequence: Yup.number().required('Sequence is required').min(1, 'Sequence must be at least 1'),
});

// Fixed Custom input component
const CustomInput = ({ field, form, parentClass, className, disabled, ...props }) => {
  const hasError = form.touched[field.name] && form.errors[field.name];

  return (
    <div className={parentClass || 'form-group'}>
      <input
        {...field}
        {...props}
        className={`${className || 'form-control'} ${hasError ? 'error' : ''}`}
        disabled={disabled}
      />
      {hasError && (
        <div className="error-message" style={{ color: 'red', fontSize: '12px', marginTop: '5px' }}>
          {form.errors[field.name]}
        </div>
      )}
    </div>
  );
};

class CreateInstrument extends Component {
  state = {
    icon: '',
    file: {},
    awsKeys: {},
    disableUpload: false,
    imgUploaded: false,
    isUploading: false,
  };

  getInitialValues = () => {
    const { mode, initialValues } = this.props;

    if (mode === 'EDIT' && initialValues) {
      return {
        id: initialValues.id,
        name: initialValues.name || '',
        description: initialValues.description || '',
        sequence: initialValues.sequence || 1,
      };
    }
    return {
      name: '',
      description: '',
      sequence: 1,
    };
  };

  componentDidMount() {
    if (this.props.mode === 'EDIT' && this.props.initialValues) {
      this.setState({
        icon: this.props.initialValues.icon || '',
        imgUploaded: !!this.props.initialValues.icon,
      });
    }
  }

  handleSubmit = (values, { setSubmitting }) => {
    const submitData = {
      ...values,
      icon: this.state.icon,
      file: this.state.file,
      awsKeys: this.state.awsKeys,
      imgUploaded: this.state.imgUploaded,
    };

    if (this.props.mode === 'EDIT') {
      this.props.onEdit({
        ...submitData,
        id: this.props.initialValues?.id
      });
    } else {
      this.props.onCreate(submitData);
    }

    setSubmitting(false);
  };

  onFileChange = async (eve) => {
    this.setState((prevState) => ({
      ...prevState,
      imgUploaded: false,
      disableUpload: false,
    }));

    const file = eve.target.files[0];
    const getAwsKey = this.props.getAwsKey;
    const fileName = file.name.replace(/ /g, '_');
    const awsKeys = await getAwsKey({ key: `instruments/images/${fileName}` });

    this.setState((prevState) => ({
      ...prevState,
      file,
      icon: `${awsKeys.action}${awsKeys.key}`,
      awsKeys,
      disableUpload: true,
    }));
  };

  uploadImg = async (eve) => {
    eve.preventDefault();
    if (!this.state.awsKeys.action) {
      toast.error('please try again.');
      return;
    }

    var form = document.getElementById('uploadImg');
    var data = new FormData(form);

    try {
      this.setState((prevState) => ({
        ...prevState,
        isUploading: true,
      }));

      await fetch(this.state.awsKeys.action, { method: 'POST', body: data });
      toast.success('Image uploaded successfully.');

      this.setState((prevState) => ({
        ...prevState,
        imgUploaded: true,
        isUploading: false,
      }));
    } catch (error) {
      toast.error('Something went wrong while uploading image.');
      this.setState((prevState) => ({
        ...prevState,
        isUploading: false,
      }));
    }
  };

  render() {
    const { mode, isCreating, accessMode } = this.props;
    const { awsKeys, disableUpload, imgUploaded, isUploading } = this.state;
    const isViewMode = accessMode === 'view';
    const isEditMode = accessMode === 'edit';

    return (
      <section className="well create-piece">
        <Formik
          initialValues={this.getInitialValues()}
          validationSchema={validationSchema}
          onSubmit={this.handleSubmit}
          enableReinitialize={true}
        >
          {({ values, isSubmitting }) => (
            <Form>
              <div className="row">
                <div className="col-md-3">
                  <label>Name</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="name"
                    type="text"
                    placeholder="Name"
                    component={CustomInput}
                    className={`form-control ${isViewMode ? 'disabled' : ''}`}
                    parentClass="form-group"
                    disabled={isViewMode}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <label>Description</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="description"
                    type="text"
                    placeholder="Description"
                    component={CustomInput}
                    className={`form-control ${isViewMode ? 'disabled' : ''}`}
                    parentClass="form-group"
                    disabled={isViewMode}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-3">
                  <label>Order</label>
                </div>
                <div className="col-md-9">
                  <Field
                    name="sequence"
                    type="number"
                    placeholder="Sequence"
                    component={CustomInput}
                    className={`form-control ${isViewMode ? 'disabled' : ''}`}
                    parentClass="form-group"
                    disabled={isViewMode}
                  />
                </div>
              </div>

              {mode === 'EDIT' && this.state.icon ? (
                <div className="row">
                  <div className="col-md-3">
                    <label>Icon</label>
                  </div>
                  <div className="col-md-9">{this.state.icon}</div>
                </div>
              ) : null}

              {isEditMode && (
                <React.Fragment>
                  <div className="row">
                    <div className="col-md-3">
                      <label>Icon</label>
                    </div>
                    <div className="col-md-9">
                      <form id="uploadImg" method="post" encType="multipart/form-data" onSubmit={this.uploadImg}>
                        <input type="hidden" name="key" value={awsKeys.key || 'NA'} />
                        <input type="hidden" name="acl" value={awsKeys.acl || 'NA'} />
                        <input type="hidden" name="X-Amz-Credential" value={awsKeys['x-amz-credential'] || 'NA'} />
                        <input type="hidden" name="X-Amz-Algorithm" value={awsKeys['x-amz-algorithm'] || 'NA'} />
                        <input type="hidden" name="X-Amz-Date" value={awsKeys['x-amz-date'] || 'NA'} />
                        <input type="hidden" name="Policy" value={awsKeys.policy || 'NA'} />
                        <input type="hidden" name="X-Amz-Signature" value={awsKeys['x-amz-signature'] || 'NA'} />
                        <input type="file" name="file" onChange={this.onFileChange} />
                        <input
                          type="submit"
                          name="submit"
                          value="Upload to Amazon S3"
                          className="btn btn-default upload-btn"
                          disabled={!disableUpload}
                        />
                      </form>
                    </div>
                  </div>

                  <div className="create-piece__btn-container">
                    <button
                      className="btn cus-btn-primary btn-block btn-lg"
                      type="submit"
                      disabled={
                        isCreating ||
                        isSubmitting ||
                        isUploading ||
                        !imgUploaded ||
                        !values.name ||
                        !values.description
                      }
                    >
                      {isCreating || isSubmitting || isUploading ? (
                        <span className="spinner" />
                      ) : (
                        <span>{mode === 'EDIT' ? 'Update' : 'Create'}</span>
                      )}
                    </button>
                  </div>
                </React.Fragment>
              )}
            </Form>
          )}
        </Formik>
      </section>
    );
  }
}

export default CreateInstrument;
